import { render } from "./IssueArticleByline.vue?vue&type=template&id=6bcc0314"
import script from "./IssueArticleByline.vue?vue&type=script&lang=js"
export * from "./IssueArticleByline.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3595080301/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__